import React, { Component } from 'react';

import { CustomPicker } from 'react-color';
import { Hue, Saturation } from 'react-color/lib/components/common';

import './ColorPicker.css';

const HuePointer = () => {
  return <div className="colorPicker__huePointer" />
}

const Picker = CustomPicker(({ hsl, hsv, onChange }) => {
  return (
    <div>
      <div className="colorPicker__saturationContainer">
        <Saturation
          hsl={hsl}
          hsv={hsv}
          onChange={onChange} />
      </div>

      <div className="colorPicker__hueContainer">
        <Hue
          direction="vertical"
          hsl={hsl}
          pointer={HuePointer}
          onChange={onChange} />
      </div>
    </div>
  );
});

class ColorPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: props.color,
      isPickerVisible: false,
    };

    this.handleColorChange = this.handleColorChange.bind(this);
    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ color: nextProps.color });
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.ref.contains(e.target)) {
      return;
    }

    this.onTriggerClick();
  }

  onTriggerClick() {
    if ( ! this.state.isPickerVisible) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      isPickerVisible: ! prevState.isPickerVisible,
    }));
  }

  handleColorChange({ hex }) {
    this.props.onChange(hex);
  }

  render() {
    const button = {
      type: 'button',
      className: 'colorPickerTrigger',
      style: { backgroundColor: this.state.color },
    };

    return (
      <div className="colorPickerContainer" ref={ref => { this.ref = ref; }}>
        <button {...button}
          onClick={this.onTriggerClick}/>

        {this.state.isPickerVisible ? (
          <div className="colorPicker">
            <Picker
              color={this.state.color}
              onChangeComplete={this.handleColorChange}
            />
            <div className="form-group form-group-sm colorPickerInput">
              <input className="form-control colorPickerInput__text" type="text"
                     value={this.state.color}
                     onChange={e => this.handleColorChange({ hex: e.target.value })} />
              <div className="colorPickerInput__preview" style={{ backgroundColor: this.state.color }} />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

ColorPicker.defaultProps = {
  onChange: console.log,
};

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/ColorPicker.js